import React from 'react';
import { WorkClockIcon } from './work-clock-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_1 } from './topic-card-shared';

import workPersonImage from './work-person.webp';

interface WorkTopicCardProps {
  title: string;
  className?: string;
}

export const WorkTopicCard: React.FC<WorkTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute left-0 top-3 h-[53px] w-[62px] shrink-0 sm:left-0 sm:top-4 sm:h-[82px] sm:w-[95px]">
          <WorkClockIcon fill={TOPIC_CARD_ICON_1} className="h-full w-full" />
        </div>
        <img
          src={workPersonImage}
          alt=""
          className="relative z-10 ml-6 aspect-[137.54/150] w-[92px] shrink-0 object-cover object-top sm:ml-8 sm:w-[137.54px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
